import { Link } from 'react-router-dom';
import Logo from './Logo';
import './Footer.css';

const homeSections = [
  { label: 'Ana Sayfa', to: '/' },
  { label: 'Hakkında', to: '/#about' },
  { label: 'Nasıl Çalışır?', to: '/#how-it-works' },
  { label: 'Özellikler', to: '/#features' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <Logo color="#4A70D8" height={34} />
            </div>
            <p className="footer__tagline">
              Öğrenciler için adil, organize ve güvenilir not paylaşımı.
            </p>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Hızlı Bağlantılar</h4>
            <ul className="footer__links">
              {homeSections.map(link => (
                <li key={link.label}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
              <li><Link to="/feedback">Geri Bildirim</Link></li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Yardım</h4>
            <ul className="footer__links">
              <li><Link to="/help">Yardım Merkezi</Link></li>
              <li><Link to="/feedback">Geri Bildirim Gönder</Link></li>
              <li><Link to="/hesap-silme">Hesap Silme</Link></li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__links-title">Yasal</h4>
            <ul className="footer__links">
              <li><Link to="/gizlilik-politikasi">Gizlilik Politikası</Link></li>
              <li><Link to="/kvkk">KVKK Aydınlatma Metni</Link></li>
              <li><Link to="/acik-riza">Açık Rıza Metni</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© 2026 NoteSwapp. Tüm hakları saklıdır.</p>
          <p className="footer__bottom-note">Öğrenciler tarafından, öğrenciler için.</p>
        </div>
      </div>
    </footer>
  );
}
